import { Visit } from '@curebase/core/types';

export default function dataCapturePassedEvaluation(
  v: Pick<Visit, 'evaluation'>
) {
  return v.evaluation?.didPass ?? false;
}
